var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSpeaker = function SvgIconSpeaker(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17.312,
    viewBox: "0 0 21.639 17.312",
    width: 21.639,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m62.815 28.856v15.144a1.08 1.08 0 0 1 -1.091 1.083 1.066 1.066 0 0 1 -.758-.317l-4.009-4.011h-4.6a1.083 1.083 0 0 1 -1.083-1.083v-6.49a1.082 1.082 0 0 1 1.083-1.082h4.6l4.009-4.011a1.062 1.062 0 0 1 .758-.317 1.08 1.08 0 0 1 1.091 1.084zm-1.443.871-3.818 3.816h-4.837v5.771h4.838l3.818 3.816zm7.213 6.7a3.141 3.141 0 0 1 -1.85 2.814.721.721 0 1 1 -.625-1.3 1.626 1.626 0 0 0 0-3.028.721.721 0 1 1 .625-1.3 3.139 3.139 0 0 1 1.851 2.816zm.323 7.117a.731.731 0 0 1 -.993-.265.722.722 0 0 1 .267-.987 6.89 6.89 0 0 0 0-11.731.722.722 0 0 1 -.267-.987.732.732 0 0 1 .993-.264 8.326 8.326 0 0 1 0 14.234z",
    transform: "translate(-51.274 -27.773)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSpeaker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-speaker.6f01ad49.svg";
export { ForwardRef as ReactComponent };